import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#59AD3B",
      d: "M13.325 0H2.34A1.51 1.51 0 0 0 .833 1.508v8.348a1.51 1.51 0 0 0 1.508 1.508H8.8V9.636a2.551 2.551 0 0 1 2.549-2.548 2.551 2.551 0 0 1 2.548 2.548v1.615a1.51 1.51 0 0 0 .937-1.395V1.508A1.51 1.51 0 0 0 13.325 0ZM4.758 1.786h6.15a.41.41 0 0 1 0 .82h-6.15a.41.41 0 0 1 0-.82Zm2.694 7.381H3a.41.41 0 0 1 0-.82h4.452a.41.41 0 1 1 0 .82Zm5.213-3.046H3a.41.41 0 0 1 0-.82h9.666a.41.41 0 1 1 0 .82Zm0-1.757H3a.41.41 0 0 1 0-.82h9.666a.41.41 0 1 1 0 .82Z"
    }, null, -1)
  ]))]))
}
export default { render: render }